export default "__VITE_ASSET__CAJTdt34__"